import { render, staticRenderFns } from "./MonitoringTag.vue?vue&type=template&id=5f79d2f6&scoped=true&lang=pug"
import script from "./MonitoringTag.vue?vue&type=script&lang=js"
export * from "./MonitoringTag.vue?vue&type=script&lang=js"
import style0 from "./MonitoringTag.vue?vue&type=style&index=0&id=5f79d2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79d2f6",
  null
  
)

export default component.exports